export default __webpack_public_path__ + "static/media/vintage100g-1.ab78fddc.jpg";